<template>
  <div class="page">
    <table class="table spacing-table discount-table">
      <tr>
        <th></th>
        <th v-for="(day, index) in dayList" :key="day.stageRuleId">
          <template v-if="index === 0">{{ $t('common.within', [`${day.value} ${$t('common.day', ['s'])}`]) }}</template>
          <template v-if="index > 0 && index < dayList.length - 1">{{ day.value }} {{ $t('common.day', ['s']) }}</template>
          <template v-if="dayList.length > 1 && index === dayList.length - 1">{{
            $t('common.moreThan', [`${day.value} ${$t('common.day', ['s'])}`])
          }}</template>
        </th>
      </tr>
      <template v-if="tableData.length > 0">
        <tr v-for="(category, categoryIndex) in categoryList" :key="category.categoryLevel2Id">
          <td>{{ category.categoryNamePath }}</td>
          <td v-for="(day, dayIndex) in dayList" :key="`${categoryIndex}-${dayIndex}`">
            <el-input v-model="tableData[categoryIndex][dayIndex].discount" size="small" @input="(val) => inputNum(val, categoryIndex, dayIndex)">
              <i slot="suffix" class="el-input__icon">%</i>
            </el-input>
          </td>
        </tr>
      </template>
    </table>
    <el-button class="mt10" type="primary" @click="submit">{{ $t('common.save') }}</el-button>
  </div>
</template>

<script>
import {
  getDiscountSecondCategoryList, getDiscountDaysList, getDiscountList, saveDiscountOnSupplyPrice,
} from '../../api/product';

export default {
  name: 'ProductSupplyPriceImport',
  data() {
    return {
      loading: false,
      categoryList: [],
      dayList: [],
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getDiscountSecondCategoryList().then((res) => {
        if (res.success && res.data) {
          this.categoryList = [
            {
              categoryLevel2Id:-1,
              categoryNamePath:"特例商品"
            },
            ...res.data];
          this.categoryLoaded = true;
          this.initTable();
        }
      });
      getDiscountDaysList().then((res) => {
        if (res.success && res.data) {
          this.dayList = res.data;
          this.dayLoaded = true;
          this.initTable();
        }
      });
      getDiscountList().then((res) => {
        if (res.success && res.data) {
          this.originData = res.data;
          this.originDataLoaded = true;
          this.initTable();
        }
      });
    },
    initTable() {
      if (this.categoryLoaded && this.dayLoaded && this.originDataLoaded) {
        const list = [];
        this.categoryList.forEach((category) => {
          const rows = [];
          this.dayList.forEach((day) => {
            let col = null;
            this.originData.some((item, index) => {
              if (item.stageRuleId === day.stageRuleId && item.categoryLevel2Id === category.categoryLevel2Id) {
                col = item;
                this.originData.splice(index, 1);
                return true;
              }
              return false;
            });
            if (col) {
              rows.push({
                stageRuleId: col.stageRuleId,
                categoryLevel2Id: col.categoryLevel2Id,
                discount: col.discount,
              });
            } else {
              rows.push({
                stageRuleId: day.stageRuleId,
                categoryLevel2Id: category.categoryLevel2Id,
                discount: null,
              });
            }
          });
          list.push(rows);
        });
        this.tableData = list;
      }
    },
    inputNum(val, categoryIndex, dayIndex) {
      // 替换掉数字和小数点 . 之外的字符
      val = val.replace(/[^\d.]/g, '');
      // 把2个以上的小数点 . 替换成一个小数点 .
      val = val.replace(/\.{2,}/g, '.');
      // 保证第一个字符为数字而不是小数点 .
      val = val.replace(/^\./g, '');
      // 保证小数点 . 只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      // 只能输入两个小数
      val = val.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.tableData[categoryIndex][dayIndex].discount = val;
    },
    submit() {
      const data = this.tableData.flat(2);
      if (data.some((item) => item.discount === null || item.discount === '')) {
        this.$message(this.$t('common.pleasecompletetheinformation'));
        return;
      }
      saveDiscountOnSupplyPrice(data).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          this.categoryLoaded = false;
          this.dayLoaded = false;
          this.originDataLoaded = false;
          this.init();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.discount-table {
  width: auto;
  th {
    min-width: 100px;
  }
}
</style>
